const enCrossLogin = {
    'cross-login-error': 'Cross login failed',
};

export default enCrossLogin;